(function (angular) {
    "use strict";

    var userService = angular.module('service.User', []);

    userService.factory('userService', ['$http', '$q', 'halClient', 'appSettings', function ($http, $q, halClient, appSettings) {

        var profileUrl = appSettings.apiBaseUri + "/user/profile";
        var listByStoreUrl = appSettings.apiBaseUri + "/user/query-by-storeId";
        var authenticateUrl = appSettings.apiBaseUri + "/user/authenticate-with-username-and-password";
        var searchUrl = appSettings.apiBaseUri + "/user/query-by-username";
        var languageUrl = appSettings.apiBaseUri + "/user/";
        var userExists = appSettings.apiBaseUri + "/user";
        var languageUrlSuffix = "/language";

        return {
            profile: function () {
                return halClient.$get(profileUrl);
            },
            userList: function (storeId) {
                return halClient.$get(listByStoreUrl + "?storeId=" + storeId);
            },
            authenticate: function (username, password) {
                return halClient.$get(authenticateUrl + "?username=" + username + "&password=" + password);
            },
            search: function (username, storeNumber) {
                var url = searchUrl + "?username=" + username;
                if (storeNumber)
                    url += "&storeNumber=" + storeNumber;
                return halClient.$get(url);
            },
            persistLanguage: function (locale) {
                return halClient.$put(languageUrl + locale + languageUrlSuffix)
            },
            exists: function (username) {
                var url = userExists + "?username="+username;
                return halClient.$get(url)
            }
        }
    }])
})(angular);